import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import BillingLogsDashboard from "../BillingLogsPage/components/BillingLogsDashboard";
import Loader from "../../components/elements/Loader";
import PageLayout from "../../layouts/PageLayout";
import api from "../../api";
import { ReduxApplicationState } from "../../types/ReduxTypes/ReduxApplicationState";

const AllBillingLogsPage = () => {
  const [billingLogs, setBillingLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const user = useSelector((state: ReduxApplicationState) => state.user);

  useEffect(() => {
    const fetchAndSetAllBillingLogs = async () => {
      try {
        setIsLoading(true);
        const fetchedBillingLogs = await api.getAllBrandgenBillingLogs(user.currentUser);
        console.log("fetchedBillingLogs: ", fetchedBillingLogs);
        setBillingLogs(fetchedBillingLogs);
        setIsLoading(false);
      } catch (error) {
        console.log(`Error in fetchAndSetAllBillingLogs: ${error}`);
        setIsLoading(false);
      }
    };

    fetchAndSetAllBillingLogs();
  }, [user.currentUser]);

  return (
    <PageLayout heading="All Billing Logs">
      {isLoading ? <Loader /> : null}
      <BillingLogsDashboard billingLogs={billingLogs} />
    </PageLayout>
  );
};

export default AllBillingLogsPage;
